import App from '../index.js';
import { isEmpty, uniqueId, now } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

App.SurveysForm = (function () {
    const elSurveyItemTemplate = $('#survey_item_template');
    let surveyTemplate = $('<div class="survey-item"></div>').html(elSurveyItemTemplate.find('.survey-item:last-child').html());
    let touched = false;

    const RESPONSE_TYPE_YES_OR_NO = 'yes_or_no';
    const RESPONSE_TYPE_THUMBS_UP_OR_DOWN = 'thumbs_up_or_down';
    const RESPONSE_TYPE_SMILEY_FACE_RATING = 'smiley_face_rating';
    const RESPONSE_TYPE_STAR_RATING = 'star_rating';
    const RESPONSE_TYPE_SLIDER = 'slider';

    function addNewRow ( e ) {
        e?.preventDefault();
        if (elSurveyItemTemplate[0]) {
            let template = surveyTemplate.clone(),
                isRequiredId = 'is_required_' + now(),
                id = uuidv4();
            template.attr('data-id', id);
            template.find('.question-field').val('');
            template.find('.id-field').val(id);
            template.find('.is-required-holder .is-required-field').attr('id', isRequiredId).closest('.is-required-holder').find('.form-check-label').attr('for', isRequiredId);
            template.find('.is-conditional-holder .is-conditional-field').attr('id', 'is_conditional_' + id).closest('.is-conditional-holder').find('.form-check-label').attr('for', 'is_conditional_' + id);
            $('.survey-body').append(template);
        }
    }

    function prepareDataToSend ( e ) {
        e.preventDefault();
        touched = false;
        window.onbeforeunload = null;

        const elForm = $(this);

        elForm.addClass('opacity-75');

        elForm.find('.survey-body .survey-item').each(function ( surveyItemIndex, event ) {
            let elItem = $(this);

            elItem.find('.id-field').attr('name', `items[${ surveyItemIndex }][id]`);

            elItem.find('.question-field').attr('name', `items[${ surveyItemIndex }][question]`);
            elItem.find('.is-required-field').attr('name', `items[${ surveyItemIndex }][is_required]`);
            elItem.find('.response-type-field').attr('name', `items[${ surveyItemIndex }][response_type]`);

            elItem.find('.response-type-option-list-item').each(function ( responseOptionIndex, event ) {
                let elResponseTypeOptionID = $(this).find('.response-type-option-id-field'),
                    elResponseTypeOptionText = $(this).find('.response-type-option-text-field');
                if (!isEmpty(elResponseTypeOptionText.val())) {
                    elResponseTypeOptionID.attr('name', `items[${ surveyItemIndex }][response_type_options][${ responseOptionIndex }][id]`);
                    elResponseTypeOptionText.attr('name', `items[${ surveyItemIndex }][response_type_options][${ responseOptionIndex }][text]`);
                }
            });

            if (!elForm.hasClass('is-locked')) {
                if ($(this).is(':last-child')) {
                    elItem.find('.id-field, .question-field, .response-type-field, .response-type-id-field, .response-type-text-field').removeAttr('name');
                }
            }

            if(elItem.find('.is-conditional-field').is(':checked')) {
                const elConditionalQuestion = elItem.find('.conditional-question-id-field');
                const elConditionalOperator = elItem.find('.conditional-question-operator-field');
                const elConditionalOperatorValue = elItem.find('.conditional-question-value-field');
                if(elConditionalQuestion.val() && elConditionalOperator.val() && elConditionalOperatorValue.val()) {
                    elConditionalQuestion.attr('name', `items[${ surveyItemIndex }][conditional_survey_item_id]`);
                    elConditionalOperator.attr('name', `items[${ surveyItemIndex }][conditional_operator]`).removeAttr('disabled');
                    elConditionalOperatorValue.attr('name', `items[${ surveyItemIndex }][conditional_operator_value]`);
                }
            }
        });

        if (elForm.hasClass('is-locked')) {
            elForm.find('.response-type-field[disabled]').removeAttr('disabled');
        }

        elForm.removeClass('opacity-75');
        elForm[0].submit();
    }

    function addNewResponseTypeOption ( e ) {
        e.preventDefault();
        const el = $(this);
        el.closest('.response-type-options-wrapper').find('.response-type-option-list').append($('#survey_item_response_type_option').html());
    }

    function updateResponseType () {
        const el = $(this);
        el.closest('.survey-item-response-type').find('.response-type-options-wrapper').toggleClass('d-none', ![ 'dropdown', 'radio_buttons', 'checkboxes' ].includes(el.val()));
    }

    function preventPageLoad () {
        if (!touched) {
            window.onbeforeunload = function () {
                return touched ? "You haven't save your changes! are you sure you want to leave?" : false;
            }
            touched = true;
        }
    }

    function onChangeConditionalChecked () {
        const el = $(this),
            elParent = el.closest('.conditional-wrapper');

        elParent.find('.conditional-content').toggleClass('d-none', !el.is(':checked'));
    }

    function onChangeConditionalQuestion () {
        const el = $(this);
        const elParent = el.closest('.survey-item');
        const elSurveyItem = $('.survey-item[data-id="' + el.val() + '"]');
        const responseType = elSurveyItem.find('.response-type-field').val();
        const elConditionalOperatorField = elParent.find('.conditional-question-operator-field');
        const elSelectedValue = parseInt(el.attr('data-conditional-operator-value') || 0);
        let options = [];

        el.attr('data-conditional-question-id', el.val());
        elConditionalOperatorField.removeAttr('disabled');

        if( responseType === RESPONSE_TYPE_YES_OR_NO ) {
            elConditionalOperatorField.val('equal_to').attr('disabled', 'disabled');
            options.push([ { id: 1, text: 'Yes' }, { id: 0, text: 'No' }, ].map(optionValue => '<option value="' + optionValue.id + '" ' + (elSelectedValue === optionValue.id ? ' selected ' : '') + '>' + optionValue.text + '</option>'));
        } else if(responseType === RESPONSE_TYPE_THUMBS_UP_OR_DOWN ) {
            elConditionalOperatorField.val('equal_to').attr('disabled', 'disabled');
            options.push([ { id: 1, text: 'Thumbs Up' }, { id: 0, text: 'Thumbs Down' }, ].map(optionValue => '<option value="' + optionValue.id + '" ' + (elSelectedValue === optionValue.id ? ' selected ' : '') + '>' + optionValue.text + '</option>'));
        } else if(responseType === RESPONSE_TYPE_SMILEY_FACE_RATING ) {
            options.push([ { id: 1, text: 'Very Dissatisfied' },
                { id: 2, text: 'Dissatisfied' },
                { id: 3, text: 'Neutral' },
                { id: 4, text: 'Satisfied' },
                { id: 5, text: 'Very Satisfied' } ].map(optionValue => '<option value="' + optionValue.id + '" ' + (elSelectedValue === optionValue.id ? ' selected ' : '') + '>' + optionValue.text + '</option>'));
        } else if(responseType === RESPONSE_TYPE_STAR_RATING ) {
            options.push([1,2,3,4,5].map(optionValue => '<option value="' + optionValue + '" ' + (elSelectedValue === optionValue ? ' selected ' : '') + '>' + optionValue + '</option>'));
        } else if(responseType === RESPONSE_TYPE_SLIDER ) {
            options.push([1,2,3,4,5,6,7,8,9,10].map(optionValue => '<option value="' + optionValue + '" ' + (elSelectedValue === optionValue ? ' selected ' : '') + '>' + optionValue + '</option>'));
        }

        elParent.find('.conditional-question-value-field').html(options.join(' '));
    }

    function getAllQuestionsArr () {
        const elSurveyItems = $('.survey-body .survey-item');
        let options = [ {
            surveyItemId: '',
            question: 'question'
        } ];

        // Get all questions with their corresponding survey item id
        $.each(elSurveyItems.find('.question-field'), function ( index, item ) {
            const el = $(item),
                elParent = el.closest('.survey-item'),
                value = el.val(),
                surveyItemId = elParent.find('.id-field').val();

            if (value && [RESPONSE_TYPE_YES_OR_NO, RESPONSE_TYPE_SLIDER, RESPONSE_TYPE_THUMBS_UP_OR_DOWN, RESPONSE_TYPE_SMILEY_FACE_RATING, RESPONSE_TYPE_STAR_RATING].includes(elParent.find('.response-type-field').val())) {
                options.push({
                    surveyItemId: surveyItemId,
                    question: value
                });
            }
        });

        return options;
    }

    function onFocusInConditionalQuestion () {
        const el = $(this);
        const elParent = el.closest('.survey-item');
        const currentlySelectedOption = el.val();
        const currentSurveyItemId = elParent.find('.id-field').val();
        const options = getAllQuestionsArr();
        const excludeOptions = $('.conditional-question-id-field[data-conditional-question-id="' + currentSurveyItemId + '"]').map(( index, item ) => $(item).closest('.survey-item').find('.id-field').val()).toArray();

        let optionItems = options.filter(optionItem => optionItem.surveyItemId !== currentSurveyItemId && !excludeOptions.includes(optionItem.surveyItemId))
            .map(optionItem => '<option value="' + optionItem.surveyItemId + '" ' + (currentlySelectedOption === optionItem.surveyItemId ? ' selected ' : '') + '>' + optionItem.question + '</option>');

        el.html(optionItems.join(' '));
    }

    return {
        init: function () {
            $('#survey_body').sortable({
                items: '.survey-item:not(:last-child)',
                handle: '.sortable-btn',
                containment: '.survey-body'
            });

            $('body')
                .on('input', '.question-field', function () {
                    const el = $(this);

                    if (el.closest('.survey-item').is(':last-child')) {
                        addNewRow();
                    }
                    preventPageLoad();
                })
                .on('input', '[name="name"]', preventPageLoad)
                .on('click', '#add_row', addNewRow)
                .on('change', '.response-type-field', updateResponseType)
                .on('click', '.add-response-type-option-item', addNewResponseTypeOption)
                .on('click', '.survey-item .delete-survey-item', function ( e ) {
                    e.preventDefault();
                    $(this).closest('.survey-item').remove();
                    preventPageLoad();
                })
                .on('click', '.response-type-option-list-item .delete-option-item .btn-delete', function ( e ) {
                    e.preventDefault();
                    $(this).closest('.response-type-option-list-item').remove();
                    preventPageLoad();
                })
                .on('change', '.is-conditional-field', onChangeConditionalChecked)
                .on('focusin', '.conditional-question-id-field', onFocusInConditionalQuestion)
                .on('change', '.conditional-question-id-field', onChangeConditionalQuestion);

            $('#survey_form').on('submit', prepareDataToSend);

            // Render conditional operator value fields.
            $('.conditional-question-id-field').trigger('change');
        }
    };

})();

// Provide the route name
App.registerRoute('organizations.surveys.create', App.SurveysForm.init);
App.registerRoute('organizations.surveys.edit', App.SurveysForm.init);

export default App.SurveysForm;
